import { BodyText } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import { ContentResponse } from '../../types/shared';
import { formatDateToDateString } from '@lib/helpers/datumhelper';

type PublishDateProps = {
  content: ContentResponse;
  options?: Intl.DateTimeFormatOptions;
};

const PublishDate: FC<PublishDateProps> = ({ content, options }): ReactNode => {
  return (
    <BodyText size="xsmall">
      {
        content.changed
          ? `Uppdaterad ${formatDateToDateString(content.changed, options)}`
          : `Publicerat ${formatDateToDateString(content.startPublish ?? new Date(), options)}`
      }
    </BodyText>
  );
};

export default PublishDate;
